import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { Actions as EMPLOYEEACTIONS } from '../../../store/actions/employeeActions';
import { Actions as GRADEACTIONS } from '../../../store/actions/gradeActions';
// import {Actions as MYACTIONS} from '../../store/actions/myActions';
// import {Actions as TEAMACTIONS} from '../../store/actions/teamActions';
import ReactDOM from "react-dom";
import DatePicker from "react-datepicker";
import { DateInputFormat } from "../../common/DateComponents";
import "react-datepicker/dist/react-datepicker.css";
import { format, addDays } from 'date-fns'

import Select from 'react-select';
import { XMarkIcon } from "@heroicons/react/20/solid";
import Spinner from "../../common/Spinner";

const GradeApplyModal = ({
  employee,
  modalStatus,
  closeModal,
  confirmGrade,
  modalSaving,
  modalSaved,
  previousDate,
}) => {

  const today = new Date();
  const [internalState, setInternalState] = useState('initial');
  const [fromDate, setFromDate] = useState(today);
  const [role, setRole] = useState("");
  const lockDate = previousDate ? addDays(new Date(previousDate), 1) : null
  const employeeName = `${employee?.employeeDetails?.givenName} ${employee?.employeeDetails?.familyName}`

  if (!modalStatus) {
    return null;
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={closeModal}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">Confirm {employeeName}'s Grade Change</h3>
            </div>
            {
              modalSaved &&
              <div className="block-content" style={{ padding: 20 }}>
                <p>{employeeName}'s Grade changes have been saved.</p>

                <button className="btn btn-success pull-right" onClick={() => closeModal()}>Close</button>
                <div className="clearfix" />
              </div>
            }
            {
              !modalSaved && internalState == 'initial' &&
              <div className="block-content" style={{ padding: 20 }}>
                <p>You're about to update {employeeName}'s Grade. You can either replace the previous values, or have the change take effect on another date.</p>

                <div style={{
                  display: 'flex',
                  flexDirection: 'row',
                }}>
                  <div style={{
                    width: "40%",
                    textAlign: 'center',
                  }}>
                    <button className="btn btn-success" onClick={() => setInternalState('replace')}>Fix a previous mistake</button>
                  </div>
                  <div style={{
                    flexGrow: 2,
                    alignSelf: 'center',
                  }}>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}>
                      <hr style={{
                        flexGrow: 1,
                        margin: 5
                      }} />
                      <span>or</span>
                      <hr style={{
                        flexGrow: 1,
                        margin: 5
                      }} />
                    </div>
                  </div>

                  <div style={{
                    width: "40%",
                    textAlign: 'center',
                  }}>
                    <button className="btn btn-success" onClick={() => setInternalState('new')}>Apply Grade for another Date</button>
                  </div>
                </div>
              </div>
            }
            {
              !modalSaved && internalState == 'new' &&
              <div className="block-content">
                <p>From when would you like {employeeName}'s new Grade to take effect?</p>

                <DatePicker
                  selected={fromDate}
                  onChange={(newFromDate) => {
                    setFromDate(newFromDate)
                  }}
                  minDate={lockDate}
                  dateFormat="do MMM yyyy"
                  customInput={<DateInputFormat />}
                />

                {modalStatus.roles && modalStatus.roles.length > 0 &&
                  <div className="form-material" style={{ marginTop: 15 }}>
                    <label htmlFor="material-text">Role</label>
                    <Select
                      options={modalStatus.roles.map(r => ({
                        value: r,
                        label: r,
                      }))}
                      value={role}
                      valueName="selected"
                      placeholder="Choose one"
                      onChange={(newRole) => {
                        setRole(newRole)
                      }}
                    />
                  </div>
                }

                <div className="block buttons">
                  {!modalSaving &&
                    <React.Fragment>
                      <button className="btn btn-danger pull-left" onClick={() => setInternalState('initial')} style={{ marginLeft: 0 }}>Go Back</button>
                      <button className="btn btn-success pull-right" onClick={() => { confirmGrade({ date: format(fromDate, "yyyy-MM-dd"), gradeId: modalStatus.id, role: role && role.value }); setInternalState('initial') }} style={{ marginRight: 0 }}>Confirm new Grade</button>
                    </React.Fragment>
                  }
                  {
                    modalSaving &&
                    <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                      <Spinner
                        style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                        className="animate-spin -ml-1 mr-3 h-5 w-5 "
                      />
                      <div style={{ float: "left" }}>Saving</div>
                    </button>
                  }

                  <div className="clearfix" />
                </div>
              </div>
            }
            {
              !modalSaved && internalState == 'replace' &&
              <div className="block-content">
                <p>You are chosing to replace {employeeName}'s previous Grade. Be aware that if you have already payslips using the current setting, these may have different values upon recalculation.</p>
                <div className="clearfix" />

                {modalStatus.roles && modalStatus.roles.length > 0 &&
                  <div className="form-material" style={{ marginTop: 15 }}>
                    <label htmlFor="material-text">Role</label>
                    <Select
                      options={modalStatus.roles.map(r => ({
                        value: r,
                        label: r,
                      }))}
                      value={role}
                      valueName="selected"
                      placeholder="Choose one"
                      onChange={(newRole) => {
                        setRole(newRole)
                      }}
                    />
                  </div>
                }

                <div className="block buttons">
                  {!modalSaving &&
                    <React.Fragment>
                      <button className="btn btn-danger pull-left" onClick={() => setInternalState('initial')} style={{ marginLeft: 0 }}>Go Back</button>
                      <button className="btn btn-success pull-right" onClick={() => { confirmGrade({ replace: true, gradeId: modalStatus.id, role: role && role.value }); setInternalState('initial') }} style={{ marginRight: 0 }}>Yes, I understand</button>
                    </React.Fragment>
                  }
                  {
                    modalSaving &&
                    <button className="btn btn-success pull-right" style={{ marginRight: 0 }}>
                      <Spinner
                        style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                        className="animate-spin -ml-1 mr-3 h-5 w-5 "
                      />
                      <div style={{ float: "left" }}>Saving</div>
                    </button>
                  }

                  <div className="clearfix" />
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {


  return {
    modalStatus: state.grades.apply,
    employee: state.employee.employeeDetails,
    // previousDate: state.employee.confirmModal.previousDate,
  }
}

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(GRADEACTIONS.gradeSetApplyModal(false)),
  confirmGrade: (options) => dispatch(EMPLOYEEACTIONS.confirmGrade(options)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GradeApplyModal) 
